import { render, staticRenderFns } from "./DocsDatasSetting.vue?vue&type=template&id=d00f8c1a&scoped=true"
import script from "./DocsDatasSetting.vue?vue&type=script&lang=js"
export * from "./DocsDatasSetting.vue?vue&type=script&lang=js"
import style0 from "./DocsDatasSetting.vue?vue&type=style&index=0&id=d00f8c1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00f8c1a",
  null
  
)

export default component.exports